import { render, staticRenderFns } from "./LSelect.vue?vue&type=template&id=48871342&"
import script from "./LSelect.vue?vue&type=script&lang=js&"
export * from "./LSelect.vue?vue&type=script&lang=js&"
import style0 from "./LSelect.vue?vue&type=style&index=0&id=48871342&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./LSelect.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports